import React from "react";

import { NumberInput } from "@common/numberInput";
import { Props } from "./types";
import styles from "./styles.scss";

function CompletionInput({ completion, readOnly, submit }: Props) {
  const [nextCompletion, setNextCompletion] = React.useState(completion);

  React.useEffect(() => {
    setNextCompletion(completion);
  }, [completion]);

  return readOnly ? (
    <div className={styles.completionInput}>
      <p className={styles.text}>{nextCompletion}%</p>
    </div>
  ) : (
    <form
      className={styles.completionInput}
      onSubmit={(e) => {
        e.preventDefault();

        nextCompletion !== completion && submit(nextCompletion);
      }}
      noValidate
    >
      <NumberInput
        className={styles.input}
        min={0}
        max={100}
        value={nextCompletion}
        input={(hours, isValid) =>
          isValid && hours >= 0 && setNextCompletion(hours)
        }
        blur={() => nextCompletion !== completion && submit(nextCompletion)}
      />
      <p className={styles.text}>%</p>
    </form>
  );
}

export { CompletionInput };
